export default "__VITE_ASSET__DcCTOR8n__"